import styled from 'styled-components';

import { Button } from '../../typography';

/* ------------------------------- HeaderIcon ------------------------------- */

export const HeaderIcon = styled(Button)(
    ({ theme }) => `
    color: ${theme.sections.header.a};
    font-size: 1.125rem;
    padding: .5rem 0 .5rem .5rem;

    &.fa {
        font-weight: bold;
    }

    @media screen and (max-width: 1080px) {
        font-size: 1rem;
    }

    &:hover {
        color: ${theme.sections.header.featureMouseover};
    }
`,
);

/* ----------------------------- HeaderDropdown ----------------------------- */

export const HeaderDropdown = styled.div`
    position: relative;
`;

/* --------------------------- HeaderDropdownMenu --------------------------- */

export const HeaderDropdownMenu = styled.ul(
    ({ theme }) => `
    background: ${theme.sections.sideMenu.background};
    border-radius: 0.25rem;
    box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.55);
    color: ${theme.sections.sideMenu.a};
    display: flex;
    flex-direction: column;
    font-size: 1rem;
    list-style: none;
    min-width: 6rem;
    overflow: hidden;
    padding: 0;
    position: absolute;
    right: -0.06rem;
    top: 100%;

    > *  {
        background: ${theme.sections.sideMenu.background};
        color: ${theme.sections.sideMenu.a};
        padding: 0.75rem 1rem;
        position: relative;
        text-align: right;
        text-decoration:none;
        transition: color 0.3s;
        white-space: nowrap;
        width: 100%;
        z-index: 100;

        &:hover {
            color: ${theme.sections.sideMenu.featureMouseover};
        }
    }
`,
);
